var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2 11.032h-2.642a1.073 1.073 0 0 1-.805-.366l-1.072-1.21a.845.845 0 0 0-1.259 0l-.917 1.037a1.58 1.58 0 0 1-1.186.539H1.855a14.986 14.986 0 0 0-.785 3.7h13.652a.875.875 0 0 0 .632-.273l1.275-1.33a.844.844 0 0 1 .606-.256h.05a.86.86 0 0 1 .632.281l1.072 1.21a1.067 1.067 0 0 0 .805.366h11.138a14.768 14.768 0 0 0-.786-3.698H24.2zM9.328 22.51a.883.883 0 0 0 .633-.271l1.27-1.33a.86.86 0 0 1 .608-.257h.054a.858.858 0 0 1 .632.282l1.067 1.21a1.082 1.082 0 0 0 .806.365h15.1c.574-1.182.99-2.437 1.234-3.729H16.233a1.077 1.077 0 0 1-.8-.36l-1.071-1.21a.844.844 0 0 0-.978-.211.825.825 0 0 0-.282.21l-.919 1.038a1.592 1.592 0 0 1-1.19.533h-9.72a14.818 14.818 0 0 0 1.23 3.74l6.825-.01zM20.042 6.986a.884.884 0 0 0 .637-.271l1.268-1.324a.84.84 0 0 1 .608-.26h.054a.825.825 0 0 1 .627.286l1.072 1.21a1.09 1.09 0 0 0 .804.36h2.87a14.985 14.985 0 0 0-23.965 0H20.04zm-5.77 19.229h-3.926a1.064 1.064 0 0 1-.8-.366l-1.067-1.21a.85.85 0 0 0-1.266 0l-.923 1.056a1.575 1.575 0 0 1-1.185.539h-.059a14.98 14.98 0 0 0 21.915 0l-12.687-.02z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApt);
export default __webpack_public_path__ + "static/media/APT.f638d0d7ef7063195d2fbf60f17fbb30.svg";
export { ForwardRef as ReactComponent };